import GridSpinner from 'components/UI/GridSpinner'
import {
  Button,
  Col,
  Container,
  Grid,
  Icon,
  Row,
  Select,
  Typography,
} from 'gu-ui-kit'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Forms/Account/Create/account-form-creation.module.scss'
import { Link } from 'react-router-dom'
import { createPath } from 'history'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { DROP_LIST, GET_LIST } from 'modules/Advertisers/List/types'

Container.propTypes = {
  display: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
}

Icon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
}
const AdvertiserTemplateSelector = ({
  onApply = () => {},
  onClose = () => {},
}) => {
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { data, loading } = useSelector((state) => state['advertisers-list'])

  const breakpoints = useBreakpoint()
  const [selectedTemplate, setSelectedTemplate] = useState()

  useEffect(() => {
    dispatch({
      type: DROP_LIST,
    })

    dispatch({
      type: GET_LIST,
      payload: {
        params: {
          name: undefined,
          offset: 0,
          limit: 1000,
          page: 1,
          status: 'active',
        },
      },
    })
  }, [])

  return (
    <>
      <Typography
        className={breakpoints.fb ? 'margin-bottom-16' : 'margin-bottom-24'}
        variant={'Body-20'}
        color="Label-Secondary"
        dangerouslySetInnerHTML={{
          __html: t('services::forms.register_account.card_advertiser.summary'),
        }}
      />

      <Grid
        display={'flex'}
        className={'margin-bottom-32'}
        flexJustify={'space-between'}
      >
        <Row justifyContent="space-between" gap={16}>
          <Col flexGrow={1}>
            <Select
              value={selectedTemplate}
              onChange={(val) => setSelectedTemplate(val)}
              label={t(
                'services::forms.register_account.fields.advertiser_template.select.label',
              )}
              normalize={(value = '') => value}
              fullWidth
              readOnly={loading}
              t={t}
              options={data.map((item) => ({
                label: '' + item.name,
                value: item.id,
              }))}
              helperText={
                !loading &&
                data.length === 0 &&
                t(
                  'services::forms.register_account.fields.advertiser_template.empty_helper',
                )
              }
              emptyOptionLabel={t('common::select_empty_option')}
              clearOptionLabel={t('common::select_clear_option')}
              ControlProps={{
                startAdornment: loading && <GridSpinner width={24} />,
              }}
            />
          </Col>

          <Col flexGrow={breakpoints.sm ? 1 : 0}>
            <Button
              fullWidth
              variant={'ghost'}
              size={'l'}
              startIcon={
                <Icon name={'plus'} className={styles['filter-button__icon']} />
              }
              component={Link}
              to={createPath({
                pathname: pathGen(ROUTES.ADVERTISER_NEW),
                search: `goBack=${
                  global.location.pathname + global.location.search
                }`,
              })}
              display={'flex'}
              className={styles['advertiser-template__add-link']}
              onClick={(e) => e.stopPropagation()}
            >
              {t('common::button_labels.add')}
            </Button>
          </Col>
        </Row>
      </Grid>

      <Grid>
        <Row
          justifyContent={breakpoints.fb ? 'center' : 'space-between'}
          direction={breakpoints.fb ? 'column-reverse' : 'row'}
          gap={breakpoints.fb ? 16 : 0}
        >
          <Button
            color={'Label-Fifth'}
            disabled={false}
            onClick={(e) => {
              e.preventDefault()
              onClose()
            }}
            variant="ghost"
            size="l"
            type="button"
          >
            {t('common::form_buttons.goBack')}
          </Button>

          <Button
            onClick={() => {
              selectedTemplate && onApply(selectedTemplate)
              onClose()
            }}
            disabled={false}
            size="l"
            variant="primary"
            type="submit"
          >
            {t(
              'services::forms.register_account.fields.advertiser_template.buttons.apply',
            )}
          </Button>
        </Row>
      </Grid>
    </>
  )
}

AdvertiserTemplateSelector.propTypes = {
  onApply: PropTypes.func,
  onClose: PropTypes.func,
}

export default AdvertiserTemplateSelector
